const MIN_GAP_WIDTH = 2;

// Returns indices of points bordering a gap. For middle gaps with real data on
// both sides, dots appear in pairs (--o  o--). For edge gaps, a single boundary
// dot is shown at the visible line endpoint.
// Gaps shorter than MIN_GAP_WIDTH only break the line without showing dots.
export const buildPairedGapEdges = <T>(
  data: T[],
  dataKey: keyof T
): Set<number> => {
  const candidateDotIndices = new Set<number>();

  const isGapAt = (index: number): boolean => {
    const value = data[index]?.[dataKey];
    return value === null || value === undefined;
  };
  let i = 0;

  while (i < data.length) {
    if (isGapAt(i)) {
      const gapStart = i;

      while (i < data.length && isGapAt(i)) {
        i++;
      }

      const gapWidth = i - gapStart;
      const hasLeftEdge = gapStart > 0;
      const hasRightEdge = i < data.length;

      if (gapWidth >= MIN_GAP_WIDTH) {
        if (hasLeftEdge) {
          candidateDotIndices.add(gapStart - 1);
        }
        if (hasRightEdge) {
          candidateDotIndices.add(i);
        }
      }
    } else {
      i++;
    }
  }

  const maxIndex = data.length - 1;

  return new Set(
    [...candidateDotIndices].filter((index) => {
      // Hide interior markers that have gaps on both sides (floating dots).
      if (index <= 0 || index >= maxIndex) {
        return true;
      }

      return !(isGapAt(index - 1) && isGapAt(index + 1));
    })
  );
};
